import { AutomatedInviteDefault } from "@/models/automated_invite_default";
import { type Module } from "vuex";
import type { State as RootState } from "@/stores";
import type { AutomatedInviteDefaultRequest, DefaultApi } from "@/api";
export interface State {
  automatedInviteDefault?: AutomatedInviteDefault;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    automatedInviteDefault: undefined,
  },
  actions: {
    // `{ commit: false }` (a reconciliation peek) fetches without touching the shared slot, so
    // a failure never resets the row to undefined for a caller who is only reconciling.
    async getAutomatedInviteDefault({ commit }, arg?: { commit?: boolean }) {
      const shouldCommit = arg?.commit !== false;
      try {
        const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
          root: true,
        });
        const response = await api.getAutomatedInviteDefault();
        const automatedInviteDefault = new AutomatedInviteDefault(
          response.data,
        );
        if (shouldCommit) {
          commit("setAutomatedInviteDefault", automatedInviteDefault);
        }
        return automatedInviteDefault;
      } catch (error) {
        if (shouldCommit) commit("setAutomatedInviteDefault", undefined);
        throw error;
      }
    },
    applyAutomatedInviteDefault(
      { commit },
      automatedInviteDefault: AutomatedInviteDefault,
    ) {
      commit("setAutomatedInviteDefault", automatedInviteDefault);
    },
    async postAutomatedInviteDefault(
      { commit },
      automatedInviteDefaultRequest: AutomatedInviteDefaultRequest,
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postAutomatedInviteDefault(
        automatedInviteDefaultRequest,
      );
      const automatedInviteDefault = new AutomatedInviteDefault(response.data);
      commit("setAutomatedInviteDefault", automatedInviteDefault);
      return automatedInviteDefault;
    },
    async applyDefaultSourceFilter() {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.applyAutomatedInviteDefaultSourceFilter();
      return response.data.updated_position_count;
    },
  },
  mutations: {
    setAutomatedInviteDefault(
      state,
      automatedInviteDefault: AutomatedInviteDefault,
    ) {
      state.automatedInviteDefault = automatedInviteDefault;
    },
  },
};
